import { Component, inject, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ERatioWidgetOperator } from 'scw-digital-boards-widgets';
import { IDropdownOption, MatDropdown } from '../../../../../shared/components/mat-dropdown/mat-dropdown.component';
import { IDropdownSettings } from '../../../../../shared/components/mat-dropdown/scw-mat-dropdown.interface';

@Component({
  imports: [MatDropdown],
  selector: 'arithmetic-operator-dropdown',
  templateUrl: './arithmetic-operator-dropdown.component.html',
})
export class ArithmeticOperatorDropdownComponent {
  private readonly translate = inject(TranslateService);

  public readonly formControl = input.required<FormControl<IDropdownOption<ERatioWidgetOperator>[]>>();
  public readonly isFormSubmitted = input.required<boolean>();

  public readonly dropdownOptions = Object.values(ERatioWidgetOperator).map((operator) => ({
    id: operator,
    name: this.translate.instant(`widget.ratio.operator.${operator}`),
  }));

  public readonly dropdownConfiguration: IDropdownSettings = {
    enableSearchFilter: false,
    hasDelayedDefaultValue: true,
    isClientSide: true,
    repositionDropdownList: true,
    singleSelection: true,
    text: this.translate.instant('page.widgetContent.addEditDialog.operator'),
  };
}
